var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 4.5,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 4.5,
    stroke: "#DBE5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5182 27.1927V23.7459C34.5182 23.4538 34.4022 23.1736 34.1956 22.967C33.989 22.7604 33.7088 22.6444 33.4167 22.6444H24.3331C23.9959 22.6444 23.6637 22.5636 23.3642 22.4087C23.0647 22.2538 22.8067 22.0294 22.6118 21.7543L21.4565 20.1233C21.2616 19.8481 21.0036 19.6237 20.7041 19.4689C20.4046 19.314 20.0724 19.2332 19.7352 19.2332H14.584C14.2918 19.2332 14.0116 19.3492 13.8051 19.5558C13.5985 19.7624 13.4824 20.0425 13.4824 20.3347V27.1927H34.5182Z",
    fill: "#8E5359"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5743 37H14.4262C14.1517 37 13.8842 36.9133 13.6619 36.7522C13.4395 36.5911 13.2738 36.364 13.1883 36.1031L11.0483 29.5761C11.0015 29.4334 10.9892 29.2817 11.0124 29.1333C11.0356 28.9849 11.0936 28.8442 11.1817 28.7226C11.2698 28.601 11.3855 28.502 11.5193 28.4337C11.653 28.3654 11.8011 28.3298 11.9512 28.3298H36.0492C36.1994 28.3298 36.3474 28.3654 36.4812 28.4337C36.615 28.502 36.7306 28.601 36.8187 28.7226C36.9068 28.8442 36.9649 28.9849 36.9881 29.1333C37.0113 29.2817 36.999 29.4334 36.9522 29.5761L34.8122 36.1031C34.7267 36.364 34.5609 36.5911 34.3386 36.7522C34.1163 36.9133 33.8488 37 33.5743 37Z",
    fill: "#8E5359"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6617 13.8263C30.1539 13.8263 28.7079 14.4253 27.6417 15.4914C26.5755 16.5576 25.9766 18.0036 25.9766 19.5114C25.9793 20.2161 26.0721 20.9175 26.2527 21.5986V21.0952C26.2527 18.5011 29.0677 16.3982 31.6617 16.3982V19.2245L35.7739 15.1122L31.6617 11V13.8263Z",
    fill: "#8E5359"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.c22d362134a07d35204638c84019d6cb.svg";
export { ForwardRef as ReactComponent };